/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import './dependencies';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import store, { persistor } from '@core/store/store';
import App from './App';
import './index.scss';
import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './i18n';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;

const root = createRoot(document.getElementById('root'));
root.render(
    <App
        store={store}
        persistor={persistor}
        basename={PUBLIC_URL}
    />
);
